module.exports = __webpack_public_path__ + "static/media/verification-photo.bc527fc3.png";